import i18n from '@/locales/i18n';
import { LanguageService, EnviromentService } from '@/services/storage.service';
import { Locale } from 'vant';
import { hasProp } from '@/utils/validate.utils';
import mapErrors from '@/utils/mapErrors.utils';

import enVant from '@/locales/en/vant';
import esVant from '@/locales/es/vant';
import frVant from '@/locales/fr/vant';
import itVant from '@/locales/it/vant';
import deVant from '@/locales/de/vant';
import ptVant from '@/locales/pt/vant';
import { IS_PRODUCTION } from '@/app.config';

const setAppMode = (context, mode) => {
  if (IS_PRODUCTION) mode = 'PROD';
  context.commit('SET_APP_MODE', mode);
  EnviromentService.saveEnviroment(mode);
};

/**
 * Establece un error global
 *
 * @param {String} errorId - Código del error
 */
const setError = ({ commit }, error) => {
  const customError = {};
  customError.errorId = error;
  customError.description = hasProp(mapErrors, error) ? mapErrors[error][1] : '';

  commit('SET_ERROR', customError);
};

/**
 * Limpia un error global
 */
const cleanError = ({ commit }) => {
  commit('SET_ERROR', {});
};

/**
 * Cambia el idioma de la aplicación
 *
 * Si el idioma es distinto del definido actualmente,
 * y si se encuentra entre los idiomas disponibles:
 *
 * @param {String} lang - Código del idioma seleccionado
 * @throws {AppError} - Language not found in to languages loader
 */
const setLanguage = ({ commit, state }, lang) => {
  if (state.languages.some(language => language === lang)) {
    i18n.locale = lang;
    LanguageService.saveLanguage(lang);
    commit('SET_LANGUAGE', lang);
    document.querySelector('html').setAttribute('lang', lang);

    switch (lang) {
      case 'es':
        Locale.use('es-ES', esVant);
        break;
      case 'fr':
        Locale.use('fr', frVant);
        break;
      case 'pt':
        Locale.use('pt_PT', ptVant);
        break;
      case 'it':
        Locale.use('it', itVant);
        break;
      case 'de':
        Locale.use('de', deVant);
        break;
      default:
        Locale.use('en-US', enVant);
    }
  } else {
    i18n.locale = 'es';
    LanguageService.saveLanguage('es');
    Locale.use('en-US', enVant);
    document.querySelector('html').setAttribute('lang', 'es');
  }
};

/**
 * Establece el modo demo
 *
 * @param {Boolean} status - Indica si el modo demos debe activarse o no
 */
const setDemo = ({ commit }, status) => {
  commit('SET_DEMO', status);
};

/**
 * Abre el menú lateral
 *
 * @param {String} lang - Código del idioma seleccionado
 * @throws {AppError} - Language not found in to languages loader
 */
const openSidenav = ({ commit }) => {
  commit('SET_SIDENAV', true);
};

/**
 * Cierra el menú lateral
 *
 * @param {String} lang - Código del idioma seleccionado
 * @throws {AppError} - Language not found in to languages loader
 */
const closeSidenav = ({ commit }) => {
  commit('SET_SIDENAV', false);
};

export default {
  setAppMode,
  setError,
  cleanError,
  setLanguage,
  setDemo,
  openSidenav,
  closeSidenav,
};
